export default

    /**
     * Class for control the cars
     */
    class VehicleController {

    constructor(resource) {
        this._resource = resource;
    }

    async getVehicles() {
        let result = null
        try {
            response = await this._resource(`vehicle/client/`).get()

            if (response.ok) {
                result = {
                    ok: true,
                    data: response.body.map((i) => {
                        i.address_street = i.address.street;
                        i.brandModel = `${i.brand} ${i.model || 'Não especificado'}`;
                    })
                }
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.message
            }
        }
        return result
    }
    async getVehiclesLastKnownPosition(vehicle) {
        let result = null

        try {
            let response = await this._resource(`vehicle/last-position/${vehicle.id}`).get()
            if (response.ok) {
                result = {
                    ok: true,
                    data: response.body
                }
            }
        }
        catch (e) {
            result = {
                ok: false,
                message: "Não foi possível encontrar as coordenadas do veículo"
            }
        }

        return result
    }
    async register(vehicle) {
        let result;
        try {
            let response = await this._resource('vehicle').save(vehicle)
            result = {
                ok: response.ok,
                message: response.body.message
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    async update(vehicle) {
        let result;
        try {
            let response = await this._resource('vehicle').update(vehicle)
            result = {
                ok: response.ok,
                message: response.body.message
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }

    delete(vehicle) {
        return this._resource(`vehicle/${vehicle.id}`)
            .delete()
            .then(res => res.json(), error => { console.log(error) });
    }

    async getAllVehicles() {
       return await this._resource(`vehicle/`).get()
       .then(res => res.body)
       .catch(err => {throw err})
    }

    getVehiclesAvaliables(begin_date, end_date, client_id, promotion_id, promotion_type) {

        return this._resource(`vehicles/client/${client_id}`)
            .get({
                begin_date,
                end_date,
                promotion_id: promotion_id ? promotion_id : null,
                promotion_type: promotion_type ? promotion_type : null
            })
            .then(res => res.body)
            .catch(error => {
                return {
                    ok: false,
                    message: error.body.message
                }
            })
    }

    async getVehiclesByType(vehicleType, client_id) {
        let result;
        try {
            let response = await this._resource(`vehicles/client/${client_id}/type/${vehicleType}`).get()
            result = response.body
        } catch (error) {
            result = {
                ok: false,
                message: error.body.message
            }
        }
        return result
    }


    async changeStatus(vehicle_id, option) {
        let result;
        try {
            let response = await this._resource(`vehicle/change-status`)
                .save({ "vehicle_id": vehicle_id, "option": option })
            result = response.body
        } catch (error) {
            result = {
                error: true,
                message: error.body.message
            }
        }
        return result
    }

    async changeStatusForce(vehicle_id, option) {
        let result;
        try {
            let response = await this._resource(`vehicle/change-status-force`)
                .save({ "vehicle_id": vehicle_id, "option": option })
            result = response.body
        } catch (error) {
            result = {
                error: true,
                message: error.body.message
            }
        }
        return result
    }

    async getAllVehicles() {
        let result
        try {
            let response = await this._resource(`vehicle`).get()
            result = response.body
        } catch (error) {
            result = {
                error: true,
                message: error.body.message
            }
        }
        return result
    }

    async getVehicleById(id) {
        let result = null;
        try {
            result = await this._resource(`vehicle/${id}`).get(id)
            if (result.ok) {
                result = {
                    ok: true,
                    data: result.body
                }
            }
        } catch (error) {
            result = {
                ok: false,
                message: error.message
            }
        }
        return result.data;
    }

    async getVehicleRequestsByVehicleId(id) {
        let result
        try {
            let response = await this._resource(`vehicle-requests/vehicle/${id}`).get()
            result = response.body
        } catch (error) {
            result = {
                error: true,
                message: error.body.message
            }
        }
        return result
    }

    async getVehiclesInArea() {
        let result
        try {
            let response = await this._resource(`vehicle/inside-garage`).get()
            result = response.body
        } catch (error) {
            result = {
                error: true,
                message: error.body.message
            }
        }
        return result
    }
}